import { getCanonicalShortCode } from './names';

export function buildMeetingPath(shortCode: unknown): string | undefined {
  const canonical = getCanonicalShortCode(shortCode);
  return canonical ? `/${canonical}` : undefined;
}

export function buildMeetingUrl(origin: string, shortCode: unknown): string | undefined {
  const pathname = buildMeetingPath(shortCode);
  if (!pathname) return undefined;
  try {
    return new URL(pathname, new URL(origin).origin).toString();
  } catch {
    return undefined;
  }
}
